var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-sheet", { staticClass: "text-center pa-2" }, [
    !_vm.chartData
      ? _c("span", [_vm._v("No Data available")])
      : _c("div", [
          _c("canvas", {
            ref: "chart",
            on: { "after-render": _vm.afterRender },
          }),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }